<template>
  <div class="vx-card">
    <div class="flex justify-between" style="padding: 1.5rem;">
      <div class="font-bold" style="font-size: 14px;"><i class="dot" /> 위험성평가 위험도(9점 이상, 약간높음) 현황</div>
      <div @click="moveDetailPage" class="cursor-pointer" style="color: rgba(var(--vs-primary),1);  font-size:0.85em; display:flex; align-items: center; justify-content: flex-end;">자세히 보기 <feather-icon icon="ChevronRightIcon" style="width:1.42em;"/></div>
    </div>
    <div style="padding: 1.5rem;">
      <apexchart type="bar" :options="chartOptions" :series="series" height="300" />
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'ImplementationStatusChart',
  mounted() {
    console.log('mounted');
    this.loadApi();
  },
  data() {
    return {
      // 그래프에서 추출하려고 하는 시설물 분류 값, 그 외에는 "기타"에 포함시킨다
      targetFacilityCategory: ['기계공학과', '토목공학과', '건축공학과', '법학과'],
      series: [
        {
          name: '기계공학과',
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        }, {
          name: '토목공학과',
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }, {
          name: '건축공학과',
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }, {
          name: '법학과',
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }, {
          name: '기타',
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }
      ],
      chartOptions: {
        chart: {
          type: 'bar',
          height: 300,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded'
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        xaxis: {
          categories: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
        },
        yaxis: {
          title: {
            text: '(건)',
          }
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter (val) {
              return `${val  }건`
            }
          }
        }
      }
    }
  },
  emits: ['update:checked-count'],
  methods: {
    moveDetailPage() {
      this.$router.push('/project/6/graph-detail/GraphDetailHSImplementationStatus');
    },
    async loadApi() {
      const data = await this.$store.dispatch('summary/LOAD_FIELD_LIST_BY_POST_VALUE', {
        projectIds: [6],
        boardIds: [450],
        dateTarget: 'content$body.inputB_4',
        dateBegin: `${(new Date()).getFullYear()  }-01-01 00:00:00`,
        dateEnd: `${(new Date()).getFullYear()  }-12-31 23:59:59`,
        valueTargets: ['body.riskAppraisalList[*].input_13_value'],
        valueOps: ['>='],
        values: ['9'],
      });
      console.log('위험도 data', data)

      const targetYear = new Date().getFullYear();

      const checkedFields = [];
      const fieldsData = data.fields;
      const fieldYearData = fieldsData[targetYear];
      for (const monthData of fieldYearData) {
        for (const field of monthData) {
          checkedFields.push(field.id);
        }
      }
      // 중복제거
      const uniqueCheckedFields = [...new Set(checkedFields)];

      const facilityCategoryData = data.facilityCategories;

      const yearData = facilityCategoryData[targetYear];

      let month = 0;
      for (const monthData of yearData) {
        // 0은 해당 년도에 대한 합산 값이므로, 처리하지 않는다
        if (month > 0) {
          for (const facilityCategoryData of monthData) {
            let isExist = false
            for (const series of this.series) {
              if (series.name === facilityCategoryData.cat3) {
                series.data[month - 1] += facilityCategoryData.count;
                isExist = true;
                break;
              }
            }
            if (!isExist) {
              for (const series of this.series) {
                if (series.name === '기타') {
                  series.data[month - 1] += facilityCategoryData.count;
                  break;
                }
              }
            }
          }
        }

        month += 1;
      }

      // Vue에서 감지할 수 있도록 새로운 배열을 만들어서 할당한다
      const newSeries = this.series.map((series) => {
        if (series.name === facilityCategoryData.cat3) {
          const newData = [...series.data];
          newData[month - 1] += facilityCategoryData.count;
          return { ...series, data: newData };
        }
        return series;
      });

      this.series = newSeries

      this.$emit('update:checked-count', uniqueCheckedFields.length);
    }
  }
}
</script>

<style scoped>

</style>
